import { getAgentByUsername, updateAgentStatus } from '@/api/customerService/auth'
import { localRead, localSave, localRemove } from '@/utils/tools'

/**
 * 客服后台模块（system-platform 内嵌）
 * agentId 由登录后 by-username 档案写入，request.js 拦截器读取注入 X-Agent-Id。
 */
/** 将缓存值规整为数字 id；空字符串 / "null" 等脏值统一归并为 null */
const normalizeAgentId = (v) => {
  if (v === null || v === undefined || v === '') return null
  if (typeof v === 'number') return v
  if (String(v).trim() === '' || String(v).trim().toLowerCase() === 'null') return null
  const n = Number(v)
  return Number.isFinite(n) && n > 0 ? n : null
}

const state = {
  agentId: normalizeAgentId(localRead('cs_agentId')),
  agentInfo: null,
  onlineStatus: null // 0=离线 1=在线 2=繁忙
}

const getters = {
  agentId: state => state.agentId,
  onlineStatus: state => state.onlineStatus
}

const mutations = {
  SET_AGENT(state, agent) {
    state.agentInfo = agent
    state.agentId = normalizeAgentId(agent && agent.id)
    if (state.agentId) localSave('cs_agentId', state.agentId)
    else { state.agentId = null; localRemove('cs_agentId') }
    if (agent && agent.onlineStatus != null) {
      state.onlineStatus = Number(agent.onlineStatus)
    }
  },
  SET_ONLINE(state, status) {
    state.onlineStatus = Number(status)
  }
}

const actions = {
  /** 登录后加载客服档案（userName 即 aics_agent.username） */
  async fetchAgentInfo({ commit }, userName) {
    if (!userName) return null
    try {
      const res = await getAgentByUsername(userName)
      if (res && res.code === 0 && res.result) {
        commit('SET_AGENT', res.result)
        return res.result
      }
    } catch (e) { /* 客服账号未配置时不阻断后台其它模块 */ }
    // 兜底：刷新恢复缓存
    const cached = localRead('cs_agentId')
    if (cached) commit('SET_AGENT', { id: cached })
    return null
  },

  /** 客服上下线（status: 0=离线 1=在线 2=繁忙），成功后才更新本地状态 */
  async setOnline({ commit, state }, status) {
    if (!state.agentId) {
      console.error('[customerService] setOnline 被跳过：无 agentId')
      return
    }
    const s = [0, 1, 2].indexOf(Number(status)) !== -1 ? Number(status) : 1
    try {
      const res = await updateAgentStatus(state.agentId, s)
      console.log('[customerService] setOnline 上报结果', state.agentId, s, res)
      commit('SET_ONLINE', s)
    } catch (e) {
      console.error('[customerService] setOnline 上报失败', state.agentId, s, e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}